export const BOUNCY_SUMS_SCREEN_TRANSITION_MS = 600;

export enum BouncySumsScreen {
	START = 'start',
	GAME = 'game',
}

export enum BouncySumsSceneStatus {
	START = 'start',
	PLAYING = 'playing',
	FINISHED = 'finished',
}

export const BOUNCY_SUMS_NUMPAD_DIGITS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];

export const BOUNCY_SUMS_MOTIVATIONAL_MESSAGE_KEYS = [
	'nice_effort',
	'keep_bouncing',
	'splashing_success',
	'excellent_dive',
	'amazing_spring',
	'fin_tastic',
];
